<template>
  <v-row>
    <v-col cols="12" md="4">
      <span class="subtitle-1" v-text="'Capítulos'" />
      <div class="wrapper-select">
        <v-select
          v-model="selected"
          class="mt-2"
          :items="itemsSelect"
          dense
          outlined
          hide-details
          @change="store.consultaListadeCapitulos"
        />
      </div>
    </v-col>
    <v-col v-if="items && items.length" cols="12">
      <v-data-table
        :items="items"
        :headers="[
          { text: 'Título', value: 'deTituloSubtitulo' },
          { text: 'Autores', value: 'autores' },
          { text: 'Paginação', value: 'dePaginacao', width: '150px' },
        ]"
      >
        <template #[`item.dePaginacao`]="{ item }">
          <a
            @click="
              $router.push({
                path:
                  `/obras/visualiza/` +
                  item.cdObra +
                  `/` +
                  TipoObra.CAPITULO_LIVRO,
                query: { back: 'true' },
              })
            "
          >
            {{ item.dePaginacao }}
          </a>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { TipoObra } from '@/constants';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { TextValue } from '@/types/common';

const store = ConsultaObrasStore();
const { obraTempImpressao: obra, listaCapitulos } = storeToRefs(store);

const items = computed(() =>
  listaCapitulos.value ? listaCapitulos.value : obra.value!.capituloList
);

const itemsSelect = computed(
  () =>
    obra.value?.localizacaoList?.map(({ volume, cdLocalizacaoLivro }) => ({
      text: volume ?? '',
      value: cdLocalizacaoLivro,
    })) ?? []
);

const selected = ref<TextValue>();

onMounted(() => {
  if (itemsSelect.value?.length) {
    selected.value = itemsSelect.value[0];
  }
});
</script>
